import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import './modal.scss';

interface ModalProps {
  width?: string;
  children: ReactNode;
}

const Modal: FC<ModalProps> = ({ children, width = '40%' }) => {
  return (
    <div className="la1-modal-background">
      <div className="la1-modal" role="dialog" style={{ width }}>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
};

Modal.displayName = 'Modal';

export default Modal;
